import { ConnectorState } from "../hooks";
import { Web3ConnectionType, Web3ConnectOptions } from "../types";
import { WalletConnect } from "./WalletConnect";
import { Url } from "./Url";
import { Network } from "./Network";
import { Metamask } from "./Metamask";
import { GnosisSafe } from "./GnosisSafe";
import { Empty } from "./Empty";
import { EIP1193 } from "./EIP1193";
import { Coinbase } from "./Coinbase";
import { BaseConnectorProps } from "./types";
import { FunctionComponent } from "react";
import { Connector as ConnectorType } from "@web3-react/types";

export interface ConnectorProps {
  type: Web3ConnectionType;
  onStateUpdate: (state: ConnectorState) => void;
  onConnectorUpdate: (connector: ConnectorType) => void;
  options: Web3ConnectOptions;
  chainId?: number;
  shouldActivate?: boolean;
}

export const Connector = ({ type, ...props }: ConnectorProps) => {
  let Component: FunctionComponent<BaseConnectorProps>;

  switch (type) {
    case Web3ConnectionType.WALLET_CONNECT:
      Component = WalletConnect;
      break;
    case Web3ConnectionType.URL:
      Component = Url;
      break;
    case Web3ConnectionType.NETWORK:
      Component = Network;
      break;
    case Web3ConnectionType.METAMASK:
      Component = Metamask;
      break;
    case Web3ConnectionType.GNOSIS_SAFE:
      Component = GnosisSafe;
      break;
    case Web3ConnectionType.EMPTY:
      Component = Empty;
      break;
    case Web3ConnectionType.EIP1193:
      Component = EIP1193;
      break;
    case Web3ConnectionType.COINBASE:
      Component = Coinbase;
      break;
    default:
      throw new Error("could not recognise connection type " + type);
  }

  return <Component key={type} {...props} />;
};
